import type { IChartState } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { minVisitsAbbrFilter } from "app/filters/ngFilters";
import { WebsiteTooltipView } from "pro-features/components/Chart/src/components/PopWithComapreChart/chartConfig";
import { translate } from "app/filters/i18nFilter";
import DurationService from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import styled from "styled-components";
import { Disclaimer } from "app/pages/industry-analysis/common/Disclaimer";

export const tooltipFormatterHof = (chartState: IChartState) => function(highChartRef) {
  return <TooltipFormatter
            chartState={chartState}
            highChartRef={highChartRef}
        />
};

const Container = styled.div`
    padding: 16px;
`;

const TooltipFormatter = (props) => {
    const { highChartRef } = props;
    const point = highChartRef.points[1];
    const comparedPoint = highChartRef.points[0];
    const params = proNavigator.getParams();
    const { duration, comparedDuration } = params;
    const { forWidget } = DurationService.getDurationData(duration, comparedDuration);
    const pointOptions = point.point.options;
    const { labelChange, displayText } = pointOptions;
    const formatter = (value) => minVisitsAbbrFilter()(value);
    const displayDisclaimer = point.point.index === 0;
    return (
        <Container>
            <WebsiteTooltipView
                metric={translate("wa.ao.graph.avgvisits")}
                change={labelChange}
                entity={{ name: displayText }}
                yFormatter={formatter}
                points={{
                    b: { y: point.y, dates: forWidget[0] },
                    a: { y: comparedPoint.y, dates: forWidget[1] },
                }}
            />
            {displayDisclaimer && (
                <Disclaimer messageKey={"market.segmentation.size.growth.bar.char.tooltip.top.sites"} />
            )}
        </Container>
    );
};
